import type { ModalProps } from "@dsk/types";
import { acceptHMRUpdate, defineStore } from "pinia";
import { reactive, toRefs } from "vue";

const STORE_ID = "globalModals";

interface State {
  articleFeedback: ModalProps;
}

export type GlobalModalId = keyof State;

const defaultOpenState: ModalProps = {
  isOpen: false
};

export const useGlobalModalsStore = defineStore(STORE_ID, () => {
  const state = reactive<State>({
    articleFeedback: { ...defaultOpenState }
  });

  const closeModal = (modalId: GlobalModalId) => {
    state[modalId].isOpen = false;
  };

  return {
    ...toRefs(state),

    closeModal
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useGlobalModalsStore, import.meta.hot));
}
